import boostedPostSeparatorConfig from "@ui/components/article/BoostedPostSeparator/config/BoostedPostSeparator.overtone.config";
import highlightConfig from "@ui/components/article/Highlight/config/Highlight.overtone.config";
import productCardConfig from "@ui/components/article/ProductCard/config/ProductCard.overtone.config";
import shareButtonsConfig from "@ui/components/article/ShareButtons/config/ShareButtons.overtone.config";
import notificationSettingsConfig from "@ui/components/auth/account/NotificationSettings/config/NotificationSettings.overtone.config";
import checkoutConfirmationConfig from "@ui/components/checkout/CheckoutConfirmation/config/CheckoutConfirmation.overtone.config";
import subscriptionCollageConfig from "@ui/components/checkout/SubscriptionCollage/config/SubscriptionCollage.overtone.config";
import compactContentCardConfig from "@ui/components/content-cards/CompactContentCard/config/CompactContentCard.overtone.config";
import contentBlockBylineConfig from "@ui/components/content-cards/ContentBlock/components/ContentBlockByline/config/ContentBlockByline.overtone.config";
import contentBlockCrossCommunityPostConfig from "@ui/components/content-cards/ContentBlock/components/ContentBlockCrossCommunityPost/config/ContentBlockCrossCommunityPost.overtone";
import contentBlockMetaConfig from "@ui/components/content-cards/ContentBlock/components/ContentBlockMeta/config/ContentBlockMeta.overtone.config";
import contentCardScoreConfig from "@ui/components/content-cards/ContentCardScore/config/ContentCardScore.overtone.config";
import prominentContentCardConfig from "@ui/components/content-cards/ProminentContentCard/config/ProminentContentCard.overtone.config";
import quickPostConfig from "@ui/components/content-cards/QuickPost/config/QuickPost.overtone.config";
import splitContentCardConfig from "@ui/components/content-cards/SplitContentCard/config/SplitContentCard.overtone.config";
import streamEntryBylineConfig from "@ui/components/content-cards/StreamEntry/components/StreamEntryByline/config/StreamEntryByline.overtone.config";
import contactFormConfig from "@ui/components/cta/ContactForm/config/ContactForm.overtone.config";
import newsletterConfig from "@ui/components/cta/Newsletter/config/Newsletter.overtone.config";
import newslettersPageCardConfig from "@ui/components/cta/NewslettersPageCard/config/NewslettersPageCard.overtone.config";
import headerPatternConfig from "@ui/components/layout/HeaderPattern/config/HeaderPattern.overtone.config";
import pageHeaderConfig from "@ui/components/layout/PageHeader/config/PageHeader.overtone.config";
import patternSwitcherConfig from "@ui/components/layout/PatternSwitcher/config/PatternSwitcher.overtone.config";
import riverConfig from "@ui/components/layout/River/config/River.overtone.config";
import userProfileContentConfig from "@ui/components/layout/UserProfileContent/config/UserProfileContent.overtone.config";
import disclaimerConfig from "@ui/components/ledes/Disclaimer/config/Disclaimer.overtone.config";
import featureFullWidthLedeConfig from "@ui/components/ledes/FeatureFullWidthLede/config/FeatureFullWidthLede.overtone.config";
import featureSquareLedeConfig from "@ui/components/ledes/FeatureSquareLede/config/FeatureSquareLede.overtone.config";
import ledeBylineConfig from "@ui/components/ledes/LedeByline/config/LedeByline.overtone.config";
import ledeMetaConfig from "@ui/components/ledes/LedeMeta/config/LedeMeta.overtone.config";
import specialFeatureFullWidthLedeConfig from "@ui/components/ledes/SpecialFeatureFullWidthLede/config/SpecialFeatureFullWidthLede.overtone.config";
import specialFeatureSquareLedeConfig from "@ui/components/ledes/SpecialFeatureSquareLede/config/SpecialFeatureSquareLede.overtone.config";
import standardLedeConfig from "@ui/components/ledes/StandardLede/config/StandardLede.overtone.config";
import embedConfig from "@ui/components/media/Embed/config/Embed.overtone.config";
import imageSliderConfig from "@ui/components/media/ImageSlider/config/ImageSlider.overtone.config";
import ledeImageConfig from "@ui/components/media/LedeImage/config/LedeImage.overtone.config";
import videoEmbedConfig from "@ui/components/media/VideoEmbed/config/VideoEmbed.overtone.config";
import metaCategoryConfig from "@ui/components/meta/Category/config/Category.overtone.config";
import metaCommentCountConfig from "@ui/components/meta/CommentCount/config/CommentCount.overtone.config";
import metaTimestampConfig from "@ui/components/meta/Timestamp/config/Timestamp.overtone.config";
import footerConfig from "@ui/components/navigation/Footer/config/Footer.overtone.config";
import navigationConfig from "@ui/components/navigation/Navigation/config/Navigation.overtone.config";
import socialLinksConfig from "@ui/components/navigation/SocialLinks/config/SocialLinks.overtone.config";
import notificationsListConfig from "@ui/components/notifications/NotificationsList/config/NotificationsList.overtone.config";
import fiveGridOverflowPatternConfig from "@ui/components/patterns/FiveGridOverflowPattern/config/FiveGridOverflowPattern.overtone.config";
import fourUpAltPatternConfig from "@ui/components/patterns/FourUpAltPattern/config/FourUpAltPattern.overtone.config";
import fourUpPatternConfig from "@ui/components/patterns/FourUpPattern/config/FourUpAltPattern.overtone.config";
import threeGridAltOverflowPatternConfig from "@ui/components/patterns/ThreeGridAltOverflowPattern/config/ThreeGridAltOverflowPattern.overtone.config";
import threeGridBigPatternConfig from "@ui/components/patterns/ThreeGridBigPattern/config/ThreeGridBigPattern.overtone.config";
import threeGridOverflowPatternConfig from "@ui/components/patterns/ThreeGridOverflowPattern/config/ThreeGridOverflowPattern.overtone.config";
import threeUpPatternConfig from "@ui/components/patterns/ThreeUpPattern/config/ThreeUpPattern.overtone.config";
import articleParentRecircConfig from "@ui/components/recirculation/ArticleParentRecirc/config/ArticleParentRecirc.overtone.config";
import articleRecircConfig from "@ui/components/recirculation/ArticleRecirc/config/ArticleRecirc.overtone.config";
import mostPopularListConfig from "@ui/components/recirculation/MostPopularList/config/MostPopularList.overtone.config";
import { ComponentConfigs } from "@ui/context/component-config-context";

const componentConfig: ComponentConfigs = {
  boostedPostSeparator: boostedPostSeparatorConfig,
  compactContentCard: compactContentCardConfig,
  contactForm: contactFormConfig,
  contentBlockMeta: contentBlockMetaConfig,
  contentBlockCrossCommunityPost: contentBlockCrossCommunityPostConfig,
  disclaimer: disclaimerConfig,
  embed: embedConfig,
  imageSlider: imageSliderConfig,
  featureFullWidthLede: featureFullWidthLedeConfig,
  featureSquareLede: featureSquareLedeConfig,
  ledeMeta: ledeMetaConfig,
  specialFeatureSquareLede: specialFeatureSquareLedeConfig,
  specialFeatureFullWidthLede: specialFeatureFullWidthLedeConfig,
  footer: footerConfig,
  headerPattern: headerPatternConfig,
  highlight: highlightConfig,
  ledeByline: ledeBylineConfig,
  ledeImage: ledeImageConfig,
  metaCategory: metaCategoryConfig,
  metaCommentCount: metaCommentCountConfig,
  metaTimestamp: metaTimestampConfig,
  navigation: navigationConfig,
  notificationsList: notificationsListConfig,
  notificationSettings: notificationSettingsConfig,
  prominentContentCard: prominentContentCardConfig,
  socialLinks: socialLinksConfig,
  pageHeader: pageHeaderConfig,
  patternSwitcher: patternSwitcherConfig,
  river: riverConfig,
  splitContentCard: splitContentCardConfig,
  standardLede: standardLedeConfig,
  fourUpAltPattern: fourUpAltPatternConfig,
  fourUpPattern: fourUpPatternConfig,
  fiveGridOverflowPattern: fiveGridOverflowPatternConfig,
  threeGridAltOverflowPattern: threeGridAltOverflowPatternConfig,
  threeGridBigPattern: threeGridBigPatternConfig,
  threeGridOverflowPattern: threeGridOverflowPatternConfig,
  threeUpPattern: threeUpPatternConfig,
  videoEmbed: videoEmbedConfig,
  shareButtons: shareButtonsConfig,
  checkoutConfirmation: checkoutConfirmationConfig,
  articleRecirc: articleRecircConfig,
  articleParentRecirc: articleParentRecircConfig,
  quickPost: quickPostConfig,
  contentBlockByline: contentBlockBylineConfig,
  mostPopularList: mostPopularListConfig,
  productCard: productCardConfig,
  contentCardScore: contentCardScoreConfig,
  newsletter: newsletterConfig,
  newslettersPageCard: newslettersPageCardConfig,
  streamEntryByline: streamEntryBylineConfig,
  subscriptionCollage: subscriptionCollageConfig,
  userProfileContent: userProfileContentConfig,
};

export default componentConfig;
